<template>
    <div class="overflow-auto d-flex justify-center md:justify-end">
      <b-pagination-nav :link-gen="linkGen" :number-of-pages="Math.ceil(totalItems/itemsPerPage)" use-router></b-pagination-nav>
    </div>
</template>

<script>
export default {
    props: {
        totalItems: Number,
        itemsPerPage: Number
    },
    methods: {
        linkGen(pageNum) {
            return pageNum === 1 ? '?' : `?page=${pageNum}`
        }
    }
}
</script>